<template>
  <div class="ce-wrapper">
    <div v-if="editMode" :class="'ce ce-' + content.type + ' ce-edit-mode'">
      <div class="edit-header d-flex align-items-center">
        <h5 class="mb-0">
          <span class="text-success"><i class="fas fa-images"></i></span>
          Bildgalleri
        </h5>
        <CeButtonGroup
          v-on:on-remove-click="onRemoveClick"
          v-on:on-arrow-up-click="onArrowUp"
          v-on:on-arrow-down-click="onArrowDown"
        />
      </div>
      <b-form-group
        label="Rubrik"
        :for="'ceImageGalleryHeadline' + content.id"
        label-sr-only
      >
        <!-- <b-form-input :value="content.headline" @change="updateHeadline" id="headline" placeholder="Skriv en rubrik..."></b-form-input> -->
        <b-form-input
          @change="updateHeadline"
          :value="content.headline"
          :id="'ceImageGalleryHeadline' + content.id"
          placeholder="Skriv en rubrik..."
        ></b-form-input>
      </b-form-group>
      <b-form-group
        label="Ladda upp bilder"
        :for="'ceImageGalleryItems' + content.id"
      >
        <b-form-file
          multiple
          no-traverse
          v-model="uploadedImages"
          accept="image/*"
          :id="'ceImageGalleryItems' + content.id"
          browse-text="Välj bilder"
          placeholder="Välj bilder eller dra &amp; släpp här..."
        >
          <template slot="file-name" slot-scope="{ names }">
            <b-badge variant="primary">
              {{ names[0] }}
            </b-badge>
            <b-badge v-if="names.length > 1" variant="dark" class="ml-1">
              + {{ names.length - 1 }} Filer till
            </b-badge>
          </template>
        </b-form-file>
      </b-form-group>
      <b-form-group>
        <div class="ce-list">
          <!-- <label>Uppladdade filer</label> -->
          <!-- v-for on the array of uploaded items -->
          <div v-if="loadingFiles">
            <div class="d-flex align-items-center">
              <strong>Laddar bilder...</strong>
              <b-spinner class="ml-auto" />
            </div>
          </div>
          <div
            class="ce-list-item"
            v-for="(image, index) in images"
            :key="image.id"
          >
            <div class="ce-list-item-prefix align-items-start">
              <span
                style="font-size: 2.25rem"
                class="text-primary"
                v-if="imageUrls[index] && imageUrls[index].src"
                ><img :src="imageUrls[index].src"
              /></span>
            </div>
            <div class="ce-list-item-action">
              <b-button
                @click="rearrangeImage(index, -1)"
                variant="flat-primary"
                size="sm"
                ><i class="fas fa-arrow-up"></i
              ></b-button>
              <b-button
                @click="rearrangeImage(index, 1)"
                variant="flat-primary"
                size="sm"
                ><i class="fas fa-arrow-down"></i
              ></b-button>
              <b-button
                @click="deleteImage(image)"
                variant="flat-primary"
                size="sm"
                ><i class="fas fa-trash"></i
              ></b-button>
            </div>
            <div class="ce-list-item-desc w-100">
              <small class="mb-0"> {{ image.fileName }} </small>
            </div>
          </div>
        </div>
      </b-form-group>
    </div>

    <div v-else :class="'ce ce-' + content.type">
      <h3 v-if="content.headline" class="ce-headline mb-1">
        {{ content.headline }}
      </h3>
      <vue-picture-swipe :items="imageUrls" :options="{ shareEl: false }">
      </vue-picture-swipe>
    </div>
  </div>
</template>

<script>
import {
  BFormGroup,
  BFormInput,
  BButton,
  BFormFile,
  BBadge,
  BSpinner,
} from "bootstrap-vue";
import VuePictureSwipe from "vue-picture-swipe"; //https://github.com/rap2hpoutre/vue-picture-swipe
import CeButtonGroup from "@/components/Article/ContentElements/CeButtonGroup";
import ContentElementButtonGroupMixin from "@/models/mixins/ContentElementButtonGroupMixin";
import ContentElementImageUploadMixin from "@/models/mixins/ContentElementImageUploadMixin";
import { createNamespacedHelpers } from "vuex";
import axios from "axios";
const { mapActions } = createNamespacedHelpers("editArticle");

export default {
  name: "CeImageGallery",
  props: {
    content: {},
    editMode: Boolean,
  },
  components: {
    VuePictureSwipe,
    CeButtonGroup,
    BFormGroup,
    BFormInput,
    BButton,
    BFormFile,
    BBadge,
    BSpinner,
  },
  data() {
    return {
      uploadedImages: [],
      images: [],
      loadingFiles: false,
      imageUrls: [],
    };
  },
  async mounted() {
    // Wait for content items, default to an empty array if undefined
    this.images = (await this.content.items) ?? [];
  },

  watch: {
    uploadedImages: function(newImages) {
      this.images = [];
      this.updateImages(newImages);
    },
    async images(newImages) {
      this.loadingFiles = true;
      //this.imageUrls = JSON.parse(JSON.stringify(this.images));
      this.imageUrls = [];
      for (let i = 0; i < newImages.length; i++) {
        const imageObject = {};
        imageObject.id = this.images[i].id;
        imageObject.fileName = this.images[i].fileName;
        imageObject.src = await this.fetchImageWithToken(
          this.images[i].original
        );
        imageObject.thumbnail = await this.fetchImageWithToken(
          this.images[i].medium
        );
        imageObject.w = this.images[i].width;
        imageObject.h = this.images[i].height;
        imageObject.small = this.images[i].small;
        this.imageUrls.push(imageObject);
      }

      this.loadingFiles = false;
    },
  },
  methods: {
    ...mapActions([
      "updateContent",
      "uploadContentImage",
      "removeContentMedia",
    ]),
    updateHeadline: function(headline) {
      let content = this.content;
      content.headline = headline;
      this.updateContent(content);
    },
    async fetchImageWithToken(imageUrl) {
      try {
        const token = JSON.parse(localStorage.getItem("user")).jwt;

        const response = await axios.get(imageUrl, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          responseType: "blob",
        });

        // use the set $ to upade the imageUrls
        return URL.createObjectURL(response.data);
      } catch (error) {
        return "";
      }
    },
    // This function must be async so we can update the render when listing the images
    updateImages: async function(images) {
      let content = this.content;
      this.loadingFiles = true;
      for (let i = 0; i < images.length; i++) {
        let payload = {
          content: content,
          image: images[i],
        };

        await this.uploadContentImage(payload).then(async (response) => {
          await this.$store
            .dispatch("fetchImageById", response.id)
            .then((response) => {
              this.images[i] = response;
              this.images[i].fileName = images[i].name;
              this.images[i].src = response.original;
              this.images[i].thumbnail = response.original;
              this.images[i].w = response.width;
              this.images[i].h = response.height;
              this.images[i].small = response.small;
            });
          this.loadingFiles = false;
        });
      }
      this.images.reverse();
      content.items = this.images;
    },
    deleteImage: function(image) {
      let content = this.content;
      this.images.splice(
        this.images.findIndex((img) => img.id === image.id),
        1
      );
      let payload = {
        content: content,
        image: image,
      };

      this.removeContentMedia(payload);
    },
    rearrangeImage: function(from, direction) {
      let item = this.images.splice(from, 1)[0];
      this.images.splice(from + direction, 0, item);

      let imageUrl = this.imageUrls.splice(from, 1)[0];
      this.imageUrls.splice(from + direction, 0, imageUrl);
    },
  },
  mixins: [ContentElementButtonGroupMixin, ContentElementImageUploadMixin],
};
</script>

<style lang="scss" scoped>
@import "src/assets/scss/variables/_variables.scss";
.ce-list-item {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding: 0.25rem;
  border-bottom: 1px solid #ebe9f1;
}
.ce-list-item-prefix {
  padding: 0.75rem 0 0.25rem 0;
  margin-right: auto;
}
.ce-list-item-prefix img {
  max-width: 5.25rem;
}
.ce-list-item-desc {
  padding: 0.25rem 0 0.5rem 0;
}
.ce-list-item-action {
  padding: 0.75rem 0 0.25rem 0;
}
</style>
